import styles from "../../styles/components/LoadingScreen.module.css";
import LoadingSpinner from "../spinner/LoadingSpinner";
import fondoUrl from "../../assets/images/fondo.png";

function LoadingScreen({
  mainText = "Cargando...",
  subText = "Por favor espera mientras cargamos todos los datos",
  embedded = false,
}) {
  return (
    <div
      className={
        embedded
          ? `${styles.loadingScreen} ${styles.embedded}`
          : styles.loadingScreen
      }
    >
      {!embedded && (
        <img
          className={styles.backgroundImg}
          alt=""
          src={fondoUrl}
          decoding="async"
          draggable={false}
        />
      )}
      <div className={styles.loadingContainer}>
        <LoadingSpinner size={60} />
        <h3>{mainText}</h3>
        {subText ? <p>{subText}</p> : null}
      </div>
    </div>
  );
}

export default LoadingScreen;
